/* tslint:disable */

declare var Object: any;
export interface PartnerContactInterface {
  "id"?: number;
  "name"?: string;
  "first_name"?: string;
  "last_name"?: string;
}

export class PartnerContact implements PartnerContactInterface {
  "id": number;
  "name": string;
  "first_name": string;
  "last_name": string;
  constructor(data?: PartnerContactInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PartnerContact`.
   */
  public static getModelName() {
    return "PartnerContact";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PartnerContact for dynamic purposes.
  **/
  public static factory(data: PartnerContactInterface): PartnerContact{
    return new PartnerContact(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PartnerContact',
      plural: 'PartnerContacts',
      path: 'PartnerContacts',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "first_name": {
          name: 'first_name',
          type: 'string'
        },
        "last_name": {
          name: 'last_name',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/PartnerContact.ts